import apiClient from '@/shared/api/client'

export interface AuditLog {
  id: string
  entity_name: string
  entity_id: string
  action: string
  performed_by: string
  performed_by_username?: string
  ip_address?: string
  before_data?: Record<string, unknown>
  after_data?: Record<string, unknown>
  created_at: string
}

interface ListParams {
  page?: number
  page_size?: number
  entity_name?: string
  entity_id?: string
  performed_by?: string
  action?: string
}

interface PaginatedResponse<T> {
  items: T[]
  total: number
  page: number
  page_size: number
}

export const auditApi = {
  list: async (params?: ListParams): Promise<PaginatedResponse<AuditLog>> => {
    const res = await apiClient.get<PaginatedResponse<AuditLog>>('/audit-logs', { params })
    return res.data
  },
}
